import { ComponentType, FrameConfiguration } from './Frame'
import { GetUrl } from './Settings'

/*
!!!!REPLACE SPACE WITH -

    ACETATE acetate
    AU750       Gold 18 carat
    CLEARLENS   Clear lenses
    CLIP-ON     Clip-On colors
!   COMB AG     Acetate / Groove Color Combination
!   COMB HG     Horn / Gold combination
!   COMB HP     Horn / Platinum combination
!   COMB TA     titanium plate / acetate combination
!   COMB TN     n.o.w. / titanium wire combination
    DIAMOND     diamond
    HORN        buffalo horn
    NOW         6500 n.o.w.
    PT950       Platinum 95%
    SILICONE    Silicone material
    SUN2        Sun lens colours (curve 2)
    SUN4        Sun lens colours (curve 4)
    SUN6        Sun lens colours (curve 6)
    T-PLATE     titanium plate
    T-WIRE      titanium wire
    T4046       T4046 - groove colours
    TRÆ         buffalo træ
*/

const combinationTypes: Record<string, string[]> = {
	'COMB-TA': ['ACETATE', 'T-PLATE'],
	'COMB-TN': ['NOW', 'T-WIRE'],
	'COMB-AG': ['ACETATE', 'T4046'],
	'COMB-HG': ['AU750', 'HORN'],
	'COMB-HP': ['PT950', 'HORN'],
	'AU750': ['AU750', 'AU750']
}

let TempleData: Record<string, { diamonds?: string[]; sizes?: string[]; hingeType?: string; endType?: string; engraving?: boolean; finishes?: string[]; detailFinishes?: string[] }> = {}

export async function GetTempleInfo() {
	const result = await fetch(GetUrl('temples.json'))
	TempleData = await result.json() as typeof TempleData
}

export function ConfigurationIntepreter(config: FrameConfiguration) {
	config = JSON.parse(JSON.stringify(config))

	let baseProductline = config.productline

	if (config.productline == 'RIMKID') {
		baseProductline = 'RIM'
		// const kids = ["BO", "CAMILLA", "FOX", "JACKIE", "JEFF", "LOUIS", "LUCAS", "OPHUS", "PANTO", "RANDY", "SKYE"]
		if (['ATTILA', 'DIRK', 'FLEMMING', 'JAIME', 'JOHN', 'MATHIAS', 'OVAL', 'RUSSEL', 'RYAN'].includes(config.components.MODEL?.design)) {
			config.productline = 'RIMTEEN' // TODO: Get From Data
		}
	} else if (config.productline == '1000TEEN' || config.productline as any == '1000 TEEN') {
		config.productline = '1000TEEN'
		baseProductline = '1000'
	} else if (config.components.MODEL?.design?.startsWith('81') && config.components.BRIDGE?.design) {
		config.isRimless = true // Override Customiser behaviour
		baseProductline = 'SPI'
	} else if (config.components.MODEL?.design?.startsWith('82')) {
		baseProductline = 'RIM'
	} else if (config.components.MODEL?.design?.startsWith('83')) {
		baseProductline = '6500'
	} else if (config.components.MODEL?.design?.startsWith('85')) {
		baseProductline = '1000'
	}

	for (const key of Object.keys(config.components)) {
		const comp = config.components[key as ComponentType]

		// Split Combination Colors to separate elements        //TODO: MOVE TO TEMPLE
		const colors = splitColorCodes(comp.color, true)
		if (colors?.length > 1) {
			const combinationType = comp.color.split('/')[0]
			if (combinationType == 'COMB-HG' || combinationType == 'COMB-HP') {
				comp.color = colors[0]
				config.components.TEMPLE_HORN = { color: colors[1] }
			} else if (combinationType == 'COMB-TA') {
				comp.color = colors[1]
				config.components.TEMPLE_ACETATE = { color: colors[0] }
			} else if (combinationType == 'COMB-TN') {
				comp.color = colors[0]
				config.components.CROSSBAR = { color: colors[1] }
			} else if (combinationType == 'COMB-AG') {
				comp.color = colors[0]
				config.components.GROOVE = { color: colors[1] }
			} else if (combinationType == 'AU750') {
				comp.color = colors[0]
				config.components.TEMPLE_DETAIL = { color: colors[1].replaceAll(/\(|\)/gi, '') } // (YG) TO YG
			} else {
				console.warn(`Unknown combination type: ${combinationType}`)
			}
		}

		// Delete Fixed sizes
		if (comp.size == 'FIXED') delete comp.size

		// Precious Move Finish from Temple Design to Color (Material) //TODO: Refactor
		if (comp.design?.includes(';')) {
			const [design, finish] = comp.design.split(';')
			comp.design = design
			if (comp.color) comp.color += '-' + finish

			// Apply same finish to other components
			if (key == 'TEMPLE') Object.keys(config.components).filter(x => x.startsWith('TEMPLE_') && !config.components[x].design && isPreciousColor(config.components[x]?.color) && !config.components[x]?.color.split('/')[1].includes('-')).forEach(x => config.components[x].color += '-' + finish)
		} else if (isPreciousColor(comp.color) && !comp.color.split('/')[1].includes('-')) {
			comp.color += '-POL'
		}

		if (isPreciousColor(comp.color)) {
			config.requiredMaterials = config.requiredMaterials || []
			if ((key == 'NOSEPAD' || key == 'FRONT' || (!config.isRimless && (key == 'BRIDGE' || key == 'CLIP'))) && !comp.color.endsWith('-POL')) {
				config.requiredMaterials.push(replaceFinish(comp.color, 'POL'))
			}
		}
	}

	/*TEMPLE */
	if (!config.components.CLIP && config.components.TEMPLE_CLIP) config.components.CLIP = config.components.TEMPLE_CLIP

	if (config.components.TEMPLE?.design) {
		if (config.components.COVER?.color && !config.components.TEMPLE.design.includes('COVER')) {
			config.components.TEMPLE.design += '_COVER'
		}

		const templeInfo = TempleData[config.components.TEMPLE?.design]
		if (!templeInfo) console.warn('NO TEMPLE INFO', config.components.TEMPLE?.design)

		if (isPreciousColor(config.components.TEMPLE.color) || (templeInfo?.hingeType != 'RIM' && templeInfo?.hingeType != 'TT')) {
			delete config.components.TEMPLE.size
		}

		if (!templeInfo?.engraving) config.engraving = null

		if (templeInfo?.hingeType && templeInfo.hingeType != 'RIM') {
			if (!isPreciousColor(config.components.TEMPLE.color)) {
				config.components.BUSHING = { design: templeInfo.hingeType, color: templeInfo.hingeType == 'TT' ? 'BUSHING/TT' : 'BUSHING/BLACK' }
			} else if (config.components.TEMPLE.color.startsWith('AU750/WG')) {
				config.components.BUSHING = { design: templeInfo.hingeType, color: 'AU750/YG-POL' }
			} else if (config.components.TEMPLE.color.startsWith('PT950/PT')) {
				config.components.BUSHING = { design: templeInfo.hingeType, color: 'PT950/PT-POL' }
			} else {
				config.components.BUSHING = { design: templeInfo.hingeType, color: 'AU750/WG-POL' }
			}
		}

		if (templeInfo?.hingeType == 'SPIRIT_WIRE') {
			config.components.CLIP = { design: templeInfo.hingeType, color: config.components.CLIP?.color }
			if (config.inclination == 0) config.components.CLIP.design += '-0'
			if (config.inclination == 5) config.components.CLIP.design += '-5'
			config.components.BUSHING = { design: templeInfo.hingeType, color: 'BUSHING/SPIRIT_WIRE' } // TODO: Correct color?
		} else if (templeInfo?.hingeType == 'SPIRIT_PLATE') {
			config.components.CLIP = { design: templeInfo.hingeType, color: config.components.CLIP?.color }
			config.components.BUSHING = { design: templeInfo.hingeType, color: 'BUSHING/BLACK' }
		} else if (config.isRimless) {
			console.warn('no clip')
		}

		if (templeInfo?.endType == 'SNAP-ON') {
			config.components.SNAP_ON = { color: isGoldTemple(config.components.TEMPLE.color) ? 'SNAP-ON/BROWN' : 'SNAP-ON/BLACK' }
		} else if (templeInfo?.endType == 'TEMPLE-TIP') {
			config.components.TEMPLE_TIP = { color: 'TEMPLE-TIP/CLEAR' }
		} else {
			console.warn('No end')
		}

		if (templeInfo?.diamonds?.length) {
			templeInfo?.diamonds.forEach((color, index) => {
				if (!config.components[`GEMSTONE-${index + 1}`]) config.components[`GEMSTONE-${index + 1}`] = { color }
			})
		}

		if (config.components.TEMPLE?.design?.startsWith('3') && !config.components.TEMPLE_DETAIL) {
			config.components.TEMPLE_DETAIL = { color: 'T-WIRE/P10' }
		}

		// Convert EEU9 to U9/EE AND EE05 to 05/EE
		if (config.components.TEMPLE?.color) config.components.TEMPLE.color = config.components.TEMPLE.color.replace(/(T-PLATE|T-WIRE)\/(E[A-Z])(P?U?\d+)/, '$1/$3/$2')

		// Titanium special colors, EB, EG, ED etc
		const match = /^(T-WIRE|T-PLATE)\/(.*)\/(E[A-Z])$/.exec(config.components.TEMPLE?.color)
		if (match) {
			config.components.TEMPLE.color = match.slice(1, 3).join('/')
			config.components.TEMPLE_DETAIL = { color: [config.components.TEMPLE.color, match[3]].join('-') }
			if (config.components.TEMPLE_DETAIL.color.endsWith('-EB')) {
				config.components.TEMPLE_DETAIL.color = match[1] + '/05'
			}
		}

		if (isPreciousColor(config.components.TEMPLE?.color)) templeInfo?.finishes?.map(x => config.requiredMaterials.push(replaceFinish(config.components.TEMPLE.color, x)))
		if (isPreciousColor(config.components.TEMPLE_DETAIL?.color) || isPreciousColor(config.components.TEMPLE?.color)) templeInfo?.detailFinishes?.map(x => config.requiredMaterials.push(replaceFinish(config.components.TEMPLE_DETAIL?.color || config.components.TEMPLE.color, x)))
	}

	delete config.components['CLIP_ON'] // NOT USED

	// Skip frames without temple
	// if(!config.components.TEMPLE) return config

	if (config.isRimless) {
		// RIMLESS REMOVE BRIDGESIZE FROM LENSES
		if (config.components.MODEL?.size) config.components.MODEL.size = parseInt(config.components.MODEL?.size).toString() // 50□20, 50#20, 50□L

		// Rename Temple Clip > CLIP and remove Bridge Clip
		delete config.components.TEMPLE_CLIP
		delete config.components['BRIDGE_CLIP'] // NOT USED
		delete config.components.CLIP?.size

		// if(config.components.BRIDGE?.design.startsWith("AIR")) delete config.components.BRIDGE.size

		if ((config.components.TEMPLE?.design.includes('_D') || config.components.TEMPLE?.design?.startsWith('0')) && !config.components.GEMSTONE?.color) {
			// config.components.GEMSTONE = config.components.GEMSTONE || {}
			// config.components.GEMSTONE.color = "DIAMOND/W" //TODO: FIX
			/*
                RIM + SPIRIT WIRE Temple with Diamonds Inside Color
                Use Yellow Gold if Precious Black, otherwise temple color
            */
			if (!config.components.TEMPLE_DETAIL?.color) config.components.TEMPLE_DETAIL = { color: config.components.TEMPLE.color.replace('AU750/BG', 'AU750/YG') }
		}
	} else {
		// NOT RIMLESS
		// Remove Front + Temple sizes until everything is modelled
		if (!config.isRimless) delete config.components.MODEL?.size
	}

	// Default Lens Color
	if (!config.components.LENSES) config.components.LENSES = { 'color': 'CLEARLENS/CLEAR' }
	if (!config.components.LENS_EDGE) {
		config.components.LENS_EDGE = {
			'color': config.components.LENSES.color == 'CLEARLENS/CLEAR' ?
				(config.isRimless ? 'CLEARLENS/EDGE-RIMLESS' : 'CLEARLENS/EDGE')
				: config.components.LENSES.color + '-EDGE'
		}
	}
	if (!config.isRimless && !config.components.GROOVE?.color) config.components.GROOVE = { 'color': config.components.LENS_EDGE.color }

	// M: Precious Oval
	// M3: Precious Oval Diamond
	// M8: Precious Oval 3 Diamonds
	// MR: Precious Round

	// S: Silicone Oval
	// SR Silicone Round

	if (!config.components.NOSEPAD) config.components.NOSEPAD = { design: baseProductline == 'RIM' || baseProductline == 'AIR' ? 'SR' : 'S', color: baseProductline == 'RIM' || baseProductline == 'AIR' ? 'SILICONE/ROUND' : 'SILICONE/OVAL' }

	if (baseProductline == 'RIM') {
		delete config.components['CLIP-ON']
		if (!config.components.CROSSBAR) config.components.CROSSBAR = {}
		if (!config.components.CROSSBAR.color) config.components.CROSSBAR.color = config.components.UPPERRIM.color
		if (!(config.components.UPPERRIM_DETAIL?.color) && config.components.UPPERRIM?.color.startsWith('T-WIRE/U3')) config.components.UPPERRIM_DETAIL = { color: 'T-WIRE/10' }

		if (config.components.GEMSTONE?.size) {
			config.components.TEMPLE.design += '_' + config.components.GEMSTONE.design + config.components.GEMSTONE.size
			config.components.TEMPLE_DETAIL = { color: config.components.TEMPLE.color.replace('AU750/BG', 'AU750/YG') }
		} else {
			delete config.components?.GEMSTONE
		}
	}

	if (baseProductline == '7000') {
		config.components.WIRE = { color: 'WIRE/CLEAR' }
	}

	if (config.components.FRONT?.color?.startsWith('HORN/') || config.components.FRONT?.color.startsWith('TRÆ/')) {
		config.components.CLIP = { color: config.components.TEMPLE.color }
		config.components.BRIDGE = { color: isPreciousColor(config.components.TEMPLE.color) ? config.components.TEMPLE.color.replace('AU750/BG', 'AU750/WG') : 'T-PLATE/P10' }
	}

	if (baseProductline == '6500') {
		config.components.NOSEPADARM = { color: 'T-WIRE/P10' }
	}

	if (baseProductline == '1000') {
		config.components.CLIP = { color: config.components.TEMPLE.color }
		config.components.BRIDGE = { color: 'T-PLATE/P10' }
	}

	return config
}

export function isPreciousColor(color: string) {
	return /^AU750|PT950/.test(color)
}

export function isGoldTemple(color: string) {
	return ['GT', 'PGT', 'YG', 'RG'].find(x => color.includes(x))
}

export function replaceFinish(colorName: string, replaceWith: string) {
	const [group, name] = colorName.split('/')
	return group + '/' + name.split('-')[0] + '-' + replaceWith
}

function splitColorCodes(color: string, combinationsOnly = false): string[] {
	if (!color) return
	const colorLineCode = color.split('/')[0]
	const colorCodes = color.substring(colorLineCode.length + 1)

	if (Object.keys(combinationTypes).includes(colorLineCode)) {
		return combinationTypes[colorLineCode].map((x, i) => colorCodes.split('/')[i] ? x + '/' + colorCodes.split('/')[i] : null).filter(Boolean)
	} else if (!combinationsOnly) {
		return [color]
	}
}
